import {alpha, SxProps, Theme} from '@mui/material';
import {ContractStatusEnum} from 'src/enums';

// No margins and no height of its own: the card is the boundary now, and the shared Table sizes itself
// the same way it does on every other list.
export const tablesx = (): SxProps<Theme> => ({
    border: 'none',
    '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
        outline: 'none !important',
    },
});

export const colTitle: SxProps<Theme> = {
    textTransform: 'uppercase',
};

export const statusSx = (theme: Theme, status: ContractStatusEnum): SxProps<Theme> => {
    const colorsMap = {
        [ContractStatusEnum.ARCHIVED]: {
            color: theme.palette.grey[900],
            backgroundColor: theme.palette.grey[200],
        },
        [ContractStatusEnum.OPERATION]: {
            color: theme.palette.primary.dark,
            backgroundColor: alpha(theme.palette.primary.light, 0.4),
        },
        [ContractStatusEnum.INSTALLATION]: {
            color: theme.palette.warning.dark,
            backgroundColor: theme.palette.warning.light,
        },
        [ContractStatusEnum.REJECTED]: {
            color: theme.palette.error.dark,
            backgroundColor: alpha(theme.palette.error.light, 0.2),
        },
        [ContractStatusEnum.VALIDATION]: {
            color: theme.palette.primary.main,
            backgroundColor: alpha(theme.palette.primary.light, 0.1),
        },
        [ContractStatusEnum.WAIT_FOR_SIGNATURE]: {
            color: theme.palette.grey[800],
            backgroundColor: theme.palette.grey[100],
        },
    };
    return {
        px: 1,
        py: 1,
        borderRadius: theme.spacing(8 / 8),
        ...colorsMap[status],
    };
};
